var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 35,
    viewBox: "0 0 65 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1014 0.0136719L0.214355 17.9007V34.1873H16.4875L34.3745 16.2868V0.0136719H18.1014Z",
    fill: "url(#paint0_linear_357_604)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2885 13.8389H36.0154V21.9754L48.227 34.187H64.5001V26.0505L52.2885 13.8389Z",
    fill: "url(#paint1_linear_357_604)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.152 0L36.0154 8.13658V12.2116H52.2885L60.4386 4.07502V0H44.152Z",
    fill: "url(#paint2_linear_357_604)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.3745 0.0134583H18.1013V16.2866H34.3745V0.0134583Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0218 21.9888L52.2949 21.9888V13.8522L36.0218 13.8522V21.9888Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.1646 4.08319L60.4377 4.08319V0.00817728L44.1646 0.00817728V4.08319Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_604",
    x1: 0.210172,
    y1: 34.1812,
    x2: 34.3777,
    y2: 0.0136491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9708CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_357_604",
    x1: 38.0505,
    y1: 11.8059,
    x2: 62.4694,
    y2: 36.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9708CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_357_604",
    x1: 39.068,
    y1: 15.2653,
    x2: 57.3821,
    y2: -3.04887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9708CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.4e412c740857c052bdffc6b140d2f005.svg";
export { ForwardRef as ReactComponent };